import { required, optional } from "AppReact/schema";

export const trainingTagsModal = {
  isVisible: required("boolean"),
  tag: required("string"),
  tagError: required("string"),
  color: required("string"),
};

export const trainingTagsModalDefaultValue = {
  isVisible: false,
  tag: "",
  tagError: "",
  color: "",
};
